import React from "react"
import G2ReviewsRating from "@/components/G2ReviewsRating"

const G2ReviewsCarousel = ({ reviews }) => {
  // Convert translation object to array if needed
  const reviewsArray = Array.isArray(reviews)
    ? reviews
    : Object.values(reviews || {})

  if (!reviewsArray.length) return null

  return (
    <section className="g2-reviews-carousel">
      <G2ReviewsRating />
      <div className="g2-reviews-carousel__outer">
        <div className="g2-reviews-carousel__track">
          {reviewsArray.map((review, i) => (
            <div className="g2-reviews-carousel__item" key={`review-${i}`}>
              "{review}"
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default G2ReviewsCarousel
